import { API_URL } from './services/settings';

const authProvider = {
	login: ({ username, password }) => {
		const request = new Request(`${API_URL}/account/login`, {
			method: 'POST',
			body: JSON.stringify({ login: username, password }),
			headers: new Headers({ 'Content-Type': 'application/json' }),
		});
		return fetch(request)
			.then(response => {
				if (response.status < 200 || response.status >= 300) {
					throw new Error(response.statusText);
				}
				return response.json();
			})
			.then(({ token, success, message }) => {
				if (!success)
					throw new Error(message);

				localStorage.setItem('token', token);
			})
			.catch((e) => {
				throw new Error(e?.message || 'Network error')
			});
	},
	checkError: (error) => {
		const { status } = error;
		if (status === 401 || status === 403) {
			localStorage.removeItem('token');
			return Promise.reject();
		}
		return Promise.resolve();
	},
	checkAuth: () => {
		return localStorage.getItem('token')
			? Promise.resolve()
			: Promise.reject();
	},
	logout: () => {
		localStorage.removeItem('token');
		return Promise.resolve();
	},
	getIdentity: () => {
		return Promise.resolve();
	},
	getPermissions: () => {
		return Promise.resolve();
	}
};

export default authProvider;
